/**
 * Tooltips & popovers - auto-initialized, dynamic content included.
 *
 * No manual init anywhere: instances are created LAZILY on the first
 * mouseover/focusin (tooltips) or click (popovers), so elements rendered
 * later (lister rows, dialogs, anything) just work.
 *
 *   - any element with a `title` (or data-bs-toggle="tooltip") gets the
 *     themed Bootstrap tooltip instead of the native browser one;
 *     opt out with `data-no-tooltip` (on the element or a container)
 *   - popovers stay explicit: data-bs-toggle="popover" + data-bs-* options
 */
export function initTooltip() {
	if (!window.bootstrap) return;

	const lazyTooltip = (e) => {
		if (!(e.target instanceof Element)) return;
		const el = e.target.closest('[title], [data-bs-toggle="tooltip"]');
		if (!el || el._lazyTip) return;
		el._lazyTip = true;
		if (el.closest('[data-no-tooltip]')) return;
		if (!(el.getAttribute('title') || '').trim() && !(el.getAttribute('data-bs-title') || '').trim()) return;
		if (el.tagName === 'IFRAME' || el.tagName === 'SELECT' || el.tagName === 'OPTION') return;
		const tip = new window.bootstrap.Tooltip(el, { container: 'body' });
		tip.show(); // the instance was created after this event fired - show now, Bootstrap handles the rest
	};

	document.addEventListener('mouseover', lazyTooltip);
	document.addEventListener('focusin', lazyTooltip);

	document.addEventListener('click', (e) => {
		if (!(e.target instanceof Element)) return;
		const el = e.target.closest('[data-bs-toggle="popover"]');
		if (!el || el._lazyPop) return;
		el._lazyPop = true;
		new window.bootstrap.Popover(el).show();
	});
}
